module.exports = __webpack_public_path__ + "static/media/dk4050.0c4f8c6f.png";